import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M11.861,3.66a2.252,2.252,0,1,1-3.185,0,2.252,2.252,0,0,1,3.185,0",
			transform: "translate(1.732 3.912)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M8.088,14.008c2.574,0,5.088,1.112,5.088,2.822V17.4a.566.566,0,0,1-.565.565H3.565A.566.566,0,0,1,3,17.4V16.83c0-1.711,2.513-2.822,5.088-2.822",
			transform: "translate(3.912 -0.873)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgMe;
